<template>
  <div class="container">
    <Menu />

    <div id="tainguyen-page">
      <div class="is-flex is-justify-between tn-dau">
        <div class="tn-tieude-chinh">
          <h1 class="title is-5">{{ lang('Tài nguyên máy chủ') }}</h1>
          <span v-if="hienTai" class="tn-phu">
            {{ hienTai.may_chu }} · {{ lang('hoạt động') }} {{ thoiGianChay(hienTai.uptime_s) }} · {{ hienTai.nhan }} {{ lang('nhân CPU') }}
          </span>
        </div>
        <div>
          <span v-if="loi" class="tn-chip tn-do">{{ loi }}</span>
          <span v-else-if="hienTai && hienTai.cu" class="tn-chip tn-cam">{{ lang('Số liệu cũ') }} {{ hienTai.tuoi_giay }}s</span>
          <span v-else-if="hienTai" class="tn-chip tn-xanh"><i class="tn-cham" /> {{ lang('Trực tiếp') }}</span>
        </div>
      </div>

      <template v-if="hienTai">
        <!-- Bốn thẻ tổng quan trên một hàng -->
        <div class="tn-luoi">
          <div class="tn-hop" :style="{ '--tn-mau': MAU.cpu }">
            <div class="tn-the-dau"><span class="tn-icon" :style="icon(MAU.cpu)"><b-icon icon="microchip" size="is-small" /></span> CPU</div>
            <div class="tn-so" :style="{ color: MAU.cpu }">{{ hienTai.cpu.tong.toFixed(1) }}<small>%</small></div>
            <div class="tn-bar"><div class="tn-bar-in" :style="bar(hienTai.cpu.tong, MAU.cpu)" /></div>
            <div class="tn-phu">{{ lang('Tải') }} {{ hienTai.tai.map(x => x.toFixed(2)).join(' / ') }}</div>
            <div class="tn-phu">{{ lang('Chờ đĩa') }} {{ hienTai.cpu.iowait }}%</div>
          </div>

          <div class="tn-hop" :style="{ '--tn-mau': MAU.ram }">
            <div class="tn-the-dau"><span class="tn-icon" :style="icon(MAU.ram)"><b-icon icon="memory" size="is-small" /></span> RAM</div>
            <div class="tn-so" :style="{ color: MAU.ram }">{{ ramPct.toFixed(1) }}<small>%</small></div>
            <div class="tn-bar"><div class="tn-bar-in" :style="bar(ramPct, MAU.ram, true)" /></div>
            <div class="tn-phu">{{ formatBytes(hienTai.ram.dung) }} / {{ formatBytes(hienTai.ram.tong) }}</div>
            <div class="tn-phu">{{ lang('Đệm') }} {{ formatBytes(hienTai.ram.dem) }} · Swap {{ formatBytes(hienTai.ram.swap_dung) }}</div>
          </div>

          <div class="tn-hop" :style="{ '--tn-mau': MAU.doc }">
            <div class="tn-the-dau"><span class="tn-icon" :style="icon(MAU.doc)"><b-icon icon="hdd" size="is-small" /></span> {{ lang('Đĩa') }} {{ hienTai.io.thiet_bi }}</div>
            <div class="tn-so tn-so-nho">
              <span :style="{ color: MAU.doc }">↓ {{ toc(hienTai.io.doc_bps) }}</span>
              <span :style="{ color: MAU.ghi }">↑ {{ toc(hienTai.io.ghi_bps) }}</span>
            </div>
            <div class="tn-bar"><div class="tn-bar-in" :style="bar(hienTai.io.ban_pct, MAU.doc)" /></div>
            <div class="tn-phu">{{ lang('Bận') }} {{ hienTai.io.ban_pct }}% · {{ hienTai.io.doc_iops }} / {{ hienTai.io.ghi_iops }} IOPS</div>
          </div>

          <div class="tn-hop" :style="{ '--tn-mau': MAU.xuong }">
            <div class="tn-the-dau"><span class="tn-icon" :style="icon(MAU.xuong)"><b-icon icon="network-wired" size="is-small" /></span> {{ lang('Mạng') }}</div>
            <div class="tn-so tn-so-nho">
              <span :style="{ color: MAU.xuong }">↓ {{ mbps(hienTai.mang_tong.xuong_bps) }}</span>
              <span :style="{ color: MAU.len }">↑ {{ mbps(hienTai.mang_tong.len_bps) }}</span>
            </div>
            <div class="tn-bar"><div class="tn-bar-in" :style="bar(mangPct, MAU.xuong)" /></div>
            <div class="tn-phu">{{ mangTen }}</div>
          </div>
        </div>
      </template>

      <!-- Ba tab: chỉ vẽ tab đang xem để trang ngắn gọn -->
      <div class="tn-tabs">
        <button v-for="t in TABS" :key="t[0]" class="tn-tab" :class="{ 'tn-tab-chon': tab === t[0] }" @click="doiTab(t[0])">{{ lang(t[1]) }}</button>
        <template v-if="tab === 'ls'">
          <span class="tn-cach" />
          <button v-for="k in KHOANG" :key="k[0]" class="button is-small" :class="{ 'is-primary': khoang === k[0] }" @click="doiKhoang(k[0])">{{ k[1] }}</button>
        </template>
        <span v-else-if="tab === 'tt'" class="tn-phu tn-ghichu">{{ lang('3 phút gần nhất, làm mới mỗi 2 giây') }}</span>
      </div>

      <!-- Tab: thời gian thực -->
      <div v-if="tab === 'tt'" class="tn-luoi4">
        <div class="tn-hop tn-hop-bd">
          <div class="tn-ten">CPU</div>
          <BieuDo :cao="CAO" :chuoi="[{ ten: 'CPU', mau: MAU.cpu, giaTri: bo.cpu }, { ten: lang('Chờ đĩa'), mau: MAU.ghi, giaTri: bo.iow, khongTo: true }]" :thoi-gian="bo.tg" :toi-da="100" :dinh-dang="v => Math.round(v) + '%'" />
        </div>
        <div class="tn-hop tn-hop-bd">
          <div class="tn-ten">RAM</div>
          <BieuDo :cao="CAO" :chuoi="[{ ten: 'RAM', mau: MAU.ram, giaTri: bo.ram }]" :thoi-gian="bo.tg" :toi-da="100" :dinh-dang="v => Math.round(v) + '%'" />
        </div>
        <div class="tn-hop tn-hop-bd">
          <div class="tn-ten">{{ lang('Đọc / ghi đĩa') }}</div>
          <BieuDo :cao="CAO" :chuoi="[{ ten: lang('Đọc'), mau: MAU.doc, giaTri: bo.doc }, { ten: lang('Ghi'), mau: MAU.ghi, giaTri: bo.ghi }]" :thoi-gian="bo.tg" :dinh-dang="toc" />
        </div>
        <div class="tn-hop tn-hop-bd">
          <div class="tn-ten">{{ lang('Mạng') }}</div>
          <BieuDo :cao="CAO" :chuoi="[{ ten: lang('Xuống'), mau: MAU.xuong, giaTri: bo.xuong }, { ten: lang('Lên'), mau: MAU.len, giaTri: bo.len }]" :thoi-gian="bo.tg" :dinh-dang="v => mbps(v * 125000)" />
        </div>
      </div>

      <!-- Tab: lịch sử -->
      <div v-else-if="tab === 'ls'" class="tn-luoi3">
        <div class="tn-hop tn-hop-bd">
          <div class="tn-ten">CPU</div>
          <BieuDo :cao="CAO" :chuoi="[{ ten: lang('Trung bình'), mau: MAU.cpu, giaTri: ls.cpu }, { ten: lang('Đỉnh'), mau: MAU.cpuDinh, giaTri: ls.cpuM, khongTo: true }]" :thoi-gian="ls.tg" :toi-da="100" :dinh-dang="v => Math.round(v) + '%'" />
        </div>
        <div class="tn-hop tn-hop-bd">
          <div class="tn-ten">RAM</div>
          <BieuDo :cao="CAO" :chuoi="[{ ten: 'RAM', mau: MAU.ram, giaTri: ls.ram }]" :thoi-gian="ls.tg" :toi-da="100" :dinh-dang="v => Math.round(v) + '%'" />
        </div>
        <div class="tn-hop tn-hop-bd">
          <div class="tn-ten">{{ lang('Tải hệ thống (load)') }}</div>
          <BieuDo :cao="CAO" :chuoi="[{ ten: lang('1 phút'), mau: MAU.tai, giaTri: ls.load }]" :thoi-gian="ls.tg" :dinh-dang="v => v.toFixed(1)" />
        </div>
        <div class="tn-hop tn-hop-bd">
          <div class="tn-ten">{{ lang('Đọc / ghi đĩa') }}</div>
          <BieuDo :cao="CAO" :chuoi="[{ ten: lang('Đọc'), mau: MAU.doc, giaTri: ls.dr }, { ten: lang('Ghi'), mau: MAU.ghi, giaTri: ls.dw }]" :thoi-gian="ls.tg" :dinh-dang="toc" />
        </div>
        <div class="tn-hop tn-hop-bd">
          <div class="tn-ten">{{ lang('Mạng') }}</div>
          <BieuDo :cao="CAO" :chuoi="[{ ten: lang('Xuống'), mau: MAU.xuong, giaTri: ls.nr }, { ten: lang('Lên'), mau: MAU.len, giaTri: ls.nt }]" :thoi-gian="ls.tg" :dinh-dang="v => mbps(v)" />
        </div>
        <div class="tn-hop tn-hop-bd">
          <div class="tn-ten">{{ lang('Mức bận của ổ đĩa') }}</div>
          <BieuDo :cao="CAO" :chuoi="[{ ten: lang('Bận'), mau: MAU.doc, giaTri: ls.io }]" :thoi-gian="ls.tg" :toi-da="100" :dinh-dang="v => Math.round(v) + '%'" />
        </div>
      </div>

      <!-- Tab: chi tiết -->
      <div v-else-if="hienTai" class="tn-luoi3">
        <div class="tn-hop">
          <div class="tn-ten">{{ lang('CPU từng nhân') }}</div>
          <div class="tn-nhan">
            <div v-for="(v, i) in hienTai.cpu.nhan" :key="i" class="tn-cot" :title="'Nhân ' + i + ': ' + Math.round(v) + '%'">
              <div class="tn-cot-khung"><div class="tn-cot-in" :style="{ height: Math.max(3, v) + '%', background: mauNguong(v, MAU.cpu) }" /></div>
              <div class="tn-cot-so">{{ i }}</div>
            </div>
          </div>
          <div class="tn-phu">{{ lang('Người dùng') }} {{ hienTai.cpu.user }}% · {{ lang('Hệ thống') }} {{ hienTai.cpu.he_thong }}%</div>
        </div>

        <div class="tn-hop">
          <div class="tn-ten">{{ lang('Nhiệt độ') }}</div>
          <div v-if="!hienTai.nhiet.length" class="tn-phu">{{ lang('Máy không cho đọc nhiệt độ.') }}</div>
          <div v-for="n in hienTai.nhiet" :key="n.ten" class="tn-nhiet">
            <span class="tn-nhiet-ten">{{ n.ten }}</span>
            <div class="tn-bar tn-bar-mong"><div class="tn-bar-in" :style="bar(Math.min(100, n.do_c), mauNhiet(n.do_c), false, true)" /></div>
            <b :style="{ color: mauNhiet(n.do_c) }">{{ n.do_c }}°C</b>
          </div>
        </div>

        <div class="tn-hop">
          <div class="tn-ten">{{ lang('Dung lượng') }}</div>
          <div v-for="d in hienTai.o_dia" :key="d.duong_dan" class="tn-oc">
            <div class="is-flex is-justify-between tn-oc-dong">
              <b>{{ d.ten }}</b>
              <b :style="{ color: mauNguong(d.dung * 100 / d.tong, MAU.ram) }">{{ (d.dung * 100 / d.tong).toFixed(1) }}%</b>
            </div>
            <div class="tn-bar"><div class="tn-bar-in" :style="bar(d.dung * 100 / d.tong, MAU.ram, true)" /></div>
            <div class="tn-phu">{{ formatBytes(d.dung) }} / {{ formatBytes(d.tong) }} · {{ lang('trống') }} {{ formatBytes(d.tong - d.dung) }}</div>
          </div>
        </div>

        <div class="tn-hop tn-rong2">
          <div class="tn-ten">
            RAID
            <span v-if="raid.trang_thai === 'tot'" class="tn-chip tn-xanh">{{ lang('Các đĩa tốt') }}</span>
            <span v-else-if="raid.trang_thai === 'canh_bao'" class="tn-chip tn-cam">{{ lang('Có cảnh báo') }}</span>
            <span v-else-if="raid.trang_thai === 'loi'" class="tn-chip tn-do">{{ lang('Có đĩa lỗi') }}</span>
            <span v-else class="tn-chip tn-xam">{{ lang('Chưa đọc được') }}</span>
          </div>
          <p class="tn-phu">{{ raid.ghi_chu }}</p>
          <div v-if="raid.o_dia && raid.o_dia.length" class="tn-cuon">
            <table class="tn-bang">
              <thead><tr><th>#</th><th>{{ lang('Đĩa') }}</th><th>{{ lang('Sức khoẻ') }}</th><th>°C</th><th>{{ lang('Giờ chạy') }}</th><th>{{ lang('Lỗi') }}</th></tr></thead>
              <tbody>
                <tr v-for="d in raid.o_dia" :key="d.so">
                  <td>{{ d.so }}</td>
                  <td>{{ d.hang_may }} <span class="tn-phu">{{ d.dung_luong }}</span></td>
                  <td><span class="tn-chip" :class="khoe(d) ? 'tn-xanh' : 'tn-do'">{{ d.suc_khoe }}</span></td>
                  <td>{{ d.nhiet || '-' }}</td>
                  <td :title="d.gio_chay ? d.gio_chay + ' giờ' : ''">{{ gioChay(d.gio_chay) }}</td>
                  <td :class="{ 'tn-canh': d.loi_cap_phat > 0 || d.cho_ghi_loi > 0 || d.loi_khong_sua > 0 }">{{ d.loi_cap_phat || 0 }} / {{ d.cho_ghi_loi || 0 }} / {{ d.loi_khong_sua || 0 }}</td>
                </tr>
              </tbody>
            </table>
            <p class="tn-phu">{{ lang('Lỗi: sector cấp phát lại / sector chờ ghi lỗi / lỗi đọc-ghi không sửa được') }}</p>
          </div>
        </div>

        <div v-if="hienTai.tien_trinh" class="tn-hop">
          <div class="tn-ten">{{ lang('Tiến trình nặng nhất') }}</div>
          <div class="tn-tt-luoi">
            <div>
              <div class="tn-phu">CPU</div>
              <div v-for="p in hienTai.tien_trinh.cpu.slice(0, 4)" :key="'c' + p.pid" class="tn-tt"><span>{{ p.ten }}</span><b :style="{ color: MAU.cpu }">{{ p.pct }}%</b></div>
              <div v-if="!hienTai.tien_trinh.cpu.length" class="tn-phu">{{ lang('Máy đang rảnh.') }}</div>
            </div>
            <div>
              <div class="tn-phu">RAM</div>
              <div v-for="p in hienTai.tien_trinh.ram.slice(0, 4)" :key="'r' + p.pid" class="tn-tt"><span>{{ p.ten }}</span><b :style="{ color: MAU.ram }">{{ formatBytes(p.bytes) }}</b></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Menu from './partials/Menu'
import BieuDo from './partials/BieuDo'
import api from '../api/api'

const GIOI_HAN = 90 // 90 diem x 2 giay = 3 phut

export default {
  name: 'TaiNguyen',
  components: { Menu, BieuDo },
  data() {
    return {
      CAO: 125,
      MAU: { cpu: '#2f80ff', cpuDinh: '#ff8a5b', ram: '#12c48b', tai: '#ffb020', doc: '#ff9500', ghi: '#ff3d71', xuong: '#8b5cf6', len: '#12b5cb' },
      TABS: [['tt', 'Thời gian thực'], ['ls', 'Lịch sử'], ['ct', 'Chi tiết']],
      KHOANG: [['1h', '1 giờ'], ['6h', '6 giờ'], ['24h', '24 giờ'], ['7d', '7 ngày'], ['30d', '30 ngày']],
      tab: 'tt',
      hienTai: null,
      loi: '',
      dangTai: false,
      bo: { tg: [], cpu: [], iow: [], ram: [], doc: [], ghi: [], xuong: [], len: [] },
      khoang: '1h',
      ls: { tg: [], cpu: [], cpuM: [], ram: [], load: [], dr: [], dw: [], io: [], nr: [], nt: [] },
      henA: null,
      henB: null,
    }
  },
  computed: {
    ramPct() {
      return this.hienTai.ram.tong ? (this.hienTai.ram.dung * 100) / this.hienTai.ram.tong : 0
    },
    raid() {
      return this.hienTai.raid || { trang_thai: 'chua_cai', ghi_chu: '', o_dia: [] }
    },
    mangDangChay() {
      return this.hienTai.mang.filter(x => x.trang_thai === 'up')
    },
    mangTen() {
      const m = this.mangDangChay[0]
      return m ? m.ten + (m.toc_do_mbps ? ' · ' + m.toc_do_mbps + ' Mbps' : '') : this.lang('Không có cổng mạng nào đang kết nối')
    },
    // Phan tram bang thong cong mang dau tien dang chay (theo chieu dang dung nhieu hon)
    mangPct() {
      const m = this.mangDangChay[0]
      if (!m || !m.toc_do_mbps) return 0
      const bps = Math.max(this.hienTai.mang_tong.xuong_bps, this.hienTai.mang_tong.len_bps) * 8
      return (bps * 100) / (m.toc_do_mbps * 1e6)
    },
  },
  mounted() {
    this.tai()
    this.henA = setInterval(this.tai, 2000)
    this.henB = setInterval(() => { if (this.tab === 'ls') this.taiLichSu() }, 60000)
  },
  beforeDestroy() {
    clearInterval(this.henA)
    clearInterval(this.henB)
  },
  methods: {
    tai() {
      if (document.hidden || this.dangTai) return
      this.dangTai = true
      api.taiNguyenHienTai()
        .then(d => {
          this.dangTai = false
          this.loi = ''
          this.hienTai = d
          this.daySo(d)
        })
        .catch(error => {
          this.dangTai = false
          const m = error && error.response && error.response.data && error.response.data.data
          this.loi = typeof m === 'string' ? m : this.lang('Unknown error')
        })
    },
    daySo(d) {
      const b = this.bo
      if (b.tg.length && b.tg[b.tg.length - 1] === d.t) return
      b.tg.push(d.t)
      b.cpu.push(d.cpu.tong)
      b.iow.push(d.cpu.iowait)
      b.ram.push(d.ram.tong ? (d.ram.dung * 100) / d.ram.tong : 0)
      b.doc.push(d.io.doc_bps)
      b.ghi.push(d.io.ghi_bps)
      b.xuong.push((d.mang_tong.xuong_bps * 8) / 1e6)
      b.len.push((d.mang_tong.len_bps * 8) / 1e6)
      Object.keys(b).forEach(k => { if (b[k].length > GIOI_HAN) b[k].shift() })
    },
    doiTab(t) {
      this.tab = t
      if (t === 'ls') this.taiLichSu()
    },
    doiKhoang(k) {
      this.khoang = k
      this.taiLichSu()
    },
    taiLichSu() {
      api.taiNguyenLichSu({ khoang: this.khoang })
        .then(r => {
          const d = r.diem
          const lay = k => d.map(p => (p[k] === undefined ? 0 : p[k]))
          this.ls = {
            tg: d.map(p => p.t), cpu: lay('cpu'), cpuM: lay('cpuM'), ram: lay('ram'), load: lay('load'),
            dr: lay('dr'), dw: lay('dw'), io: lay('io'), nr: lay('nr'), nt: lay('nt'),
          }
        })
        .catch(() => {})
    },
    icon(mau) {
      return { background: mau + '22', color: mau }
    },
    mauNguong(pct, mau) {
      return pct >= 90 ? '#ff3d71' : pct >= 75 ? '#ffb020' : mau
    },
    mauNhiet(c) {
      return c >= 70 ? '#ff3d71' : c >= 55 ? '#ffb020' : '#12c48b'
    },
    bar(pct, mau, doiMau, giuMau) {
      const m = doiMau && !giuMau ? this.mauNguong(pct, mau) : mau
      return { width: Math.max(0, Math.min(100, pct)) + '%', background: 'linear-gradient(90deg,' + m + 'bb,' + m + ')' }
    },
    gioChay(h) {
      const n = parseInt(h, 10)
      if (!n) return '-'
      const nam = n / 8766
      return n.toLocaleString('vi-VN') + ' h' + (nam >= 1 ? ' (' + nam.toFixed(1).replace('.', ',') + ' ' + this.lang('năm') + ')' : '')
    },
    khoe(d) {
      return ['PASSED', 'OK'].indexOf(String(d.suc_khoe).toUpperCase()) !== -1
    },
    toc(bps) {
      return this.formatBytes(bps) + '/s'
    },
    mbps(bps) {
      const bit = bps * 8
      if (bps < 0.5) return '0 Mbps'
      return bit >= 1e6 ? (bit / 1e6).toFixed(bit >= 1e8 ? 0 : 1) + ' Mbps' : (bit / 1e3).toFixed(0) + ' Kbps'
    },
    thoiGianChay(s) {
      const n = Math.floor(s / 86400)
      const g = Math.floor((s % 86400) / 3600)
      const p = Math.floor((s % 3600) / 60)
      return (n ? n + ' ' + this.lang('ngày') + ' ' : '') + g + ' ' + this.lang('giờ') + ' ' + p + ' ' + this.lang('phút')
    },
  },
}
</script>

<style scoped>
#tainguyen-page { margin-top: 0.9rem; padding: 0.9rem 1rem 1.2rem; background: #e3e9f1; border-radius: 14px; }
@media (prefers-color-scheme: dark) { #tainguyen-page { background: #1a1e24; } }
.tn-dau { align-items: center; margin-bottom: 0.7rem; gap: 0.6rem; flex-wrap: wrap; }
.tn-tieude-chinh { display: flex; align-items: baseline; gap: 0.8rem; flex-wrap: wrap; }
.tn-tieude-chinh .title { margin: 0; }
.tn-phu { font-size: 0.78rem; opacity: 0.7; }
.tn-luoi { display: grid; grid-template-columns: repeat(auto-fit, minmax(205px, 1fr)); gap: 0.7rem; margin-bottom: 0.8rem; }
.tn-luoi4 { display: grid; grid-template-columns: repeat(auto-fit, minmax(215px, 1fr)); gap: 0.7rem; }
.tn-luoi3 { display: grid; grid-template-columns: repeat(auto-fit, minmax(290px, 1fr)); gap: 0.7rem; }
.tn-rong2 { grid-column: span 2; }
@media (max-width: 700px) { .tn-rong2 { grid-column: span 1; } }
.tn-hop { --tn-mau: #9aabc4; background: #f8fafc; border: 1px solid #b9c5d6; border-top: 4px solid var(--tn-mau); border-radius: 12px; padding: 0.7rem 0.85rem; min-width: 0; box-shadow: 0 2px 4px rgba(31, 45, 70, 0.1), 0 6px 16px rgba(31, 45, 70, 0.1); transition: box-shadow 0.2s, transform 0.2s; }
.tn-hop:hover { box-shadow: 0 3px 6px rgba(31, 45, 70, 0.14), 0 10px 24px rgba(31, 45, 70, 0.16); transform: translateY(-1px); }
@media (prefers-color-scheme: dark) {
  .tn-hop { background: #252b33; border-color: #3d4655; border-top-color: var(--tn-mau); box-shadow: 0 2px 4px rgba(0, 0, 0, 0.45), 0 6px 16px rgba(0, 0, 0, 0.4); }
  .tn-hop:hover { box-shadow: 0 3px 6px rgba(0, 0, 0, 0.55), 0 10px 24px rgba(0, 0, 0, 0.5); }
}
.tn-hop-bd { padding-bottom: 0.5rem; }
.tn-the-dau { display: flex; align-items: center; gap: 0.45rem; font-weight: 600; font-size: 0.9rem; margin-bottom: 0.15rem; }
.tn-icon { display: inline-flex; width: 24px; height: 24px; border-radius: 8px; align-items: center; justify-content: center; }
.tn-so { font-size: 1.65rem; font-weight: 700; line-height: 1.2; }
.tn-so small { font-size: 0.85rem; font-weight: 600; margin-left: 2px; }
.tn-so-nho { font-size: 0.95rem; display: flex; flex-direction: column; gap: 0; }
.tn-bar { height: 8px; background: rgba(127, 140, 160, 0.28); border-radius: 5px; overflow: hidden; margin: 0.25rem 0 0.3rem; }
.tn-bar-mong { height: 6px; margin: 0; }
.tn-bar-in { height: 100%; border-radius: 5px; transition: width 0.6s ease; }
.tn-ten { font-weight: 600; font-size: 0.88rem; margin-bottom: 0.3rem; display: flex; align-items: center; gap: 0.6rem; }
.tn-chip { display: inline-block; padding: 1px 9px; border-radius: 999px; font-size: 0.75rem; font-weight: 600; }
.tn-xanh { background: #12c48b22; color: #0aa673; }
.tn-cam { background: #ffb02033; color: #c98100; }
.tn-canh { color: #c98100; font-weight: 600; }
.tn-do { background: #ff3d7122; color: #e0245e; }
.tn-xam { background: rgba(127, 140, 160, 0.2); }
.tn-cham { display: inline-block; width: 8px; height: 8px; border-radius: 50%; background: #12c48b; margin-right: 4px; animation: tn-nhap 1.4s infinite; }
@keyframes tn-nhap { 0%, 100% { opacity: 1; } 50% { opacity: 0.3; } }
.tn-tabs { display: flex; align-items: center; gap: 0.35rem; flex-wrap: wrap; border-bottom: 1px solid rgba(127, 140, 160, 0.25); padding-bottom: 0.5rem; margin-bottom: 0.7rem; }
.tn-tab { background: transparent; border: 0; padding: 0.35rem 0.9rem; border-radius: 999px; cursor: pointer; font-size: 0.88rem; font-weight: 600; color: inherit; opacity: 0.7; }
.tn-tab:hover { opacity: 1; background: rgba(127, 140, 160, 0.15); }
.tn-tab-chon { opacity: 1; background: #2f80ff; color: #fff; }
.tn-tab-chon:hover { background: #2f80ff; }
.tn-cach { width: 0.8rem; }
.tn-ghichu { margin-left: 0.6rem; }
.tn-nhan { display: flex; gap: 4px; align-items: flex-end; margin: 0.2rem 0 0.3rem; }
.tn-cot { flex: 1; min-width: 0; text-align: center; }
.tn-cot-khung { height: 60px; background: rgba(127, 140, 160, 0.2); border-radius: 4px; display: flex; align-items: flex-end; overflow: hidden; }
.tn-cot-in { width: 100%; border-radius: 4px; transition: height 0.6s ease; }
.tn-cot-so { font-size: 0.65rem; opacity: 0.6; margin-top: 2px; }
.tn-nhiet { display: grid; grid-template-columns: 72px 1fr auto; gap: 0.5rem; align-items: center; margin-bottom: 0.45rem; font-size: 0.85rem; }
.tn-oc { margin-bottom: 0.55rem; }
.tn-oc-dong { font-size: 0.85rem; }
.tn-tt-luoi { display: grid; grid-template-columns: 1fr 1fr; gap: 0.8rem; }
.tn-tt { display: flex; justify-content: space-between; gap: 0.4rem; padding: 2px 0; border-bottom: 1px solid rgba(127, 140, 160, 0.18); font-size: 0.82rem; }
.tn-tt span { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.tn-cuon { overflow-x: auto; }
.tn-bang { width: 100%; font-size: 0.8rem; border-collapse: collapse; }
.tn-bang th { text-align: left; font-weight: 600; opacity: 0.7; padding: 3px 6px; }
.tn-bang td { padding: 4px 6px; border-top: 1px solid rgba(127, 140, 160, 0.18); vertical-align: top; }
</style>
